import {FETCHING_DATA, DATA_FETCHED, ERROR_FETCHING, CLEAR_ERROR} from '../../actions/actionTypes';

export function fetchingReducer(state = {}, action) {
    switch (action.type) {
        case FETCHING_DATA:
            return {isFetching: true, fetchingType: action.fetchingType};
        case DATA_FETCHED:
            //if fetchingType is not the current fetchingType on state then don't reset it
            if (action.fetchingType)
                if (action.fetchingType !== state.fetchingType)
                    return state;
            return {isFetching: false};
        case ERROR_FETCHING:
            return {isFetching: false,
                error: {error: action.error, message: action.error.message, retryAction: action.retryAction}};
        case CLEAR_ERROR:
            return {};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/common/fetchingReducer.js